import { render } from "./Deleted_task.vue?vue&type=template&id=eddca1d4"
import script from "./Deleted_task.vue?vue&type=script&lang=js"
export * from "./Deleted_task.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__